import { Link } from "react-router-dom";
import Button from "@/components/base/Button";
import { useT } from "@/lib/useSiteText";

export default function NotFound() {
  const t = useT();
  const texto = t("notfound.texto");
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mt-6">
          {t("notfound.titulo")}
        </h2>
        {texto && <p className="mt-3 text-base text-foreground-600 max-w-md">{texto}</p>}
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button to="/">{t("notfound.boton_inicio")}</Button>
          <Link
            to="/bodegas"
            className="text-sm font-semibold text-primary-600 hover:text-primary-700 transition"
          >
            {t("notfound.enlace_bodegas")}
          </Link>
        </div>
      </div>
    </div>
  );
}